import { gql } from '@apollo/client';

export const FIND_PALLET_TAGS = gql`
  query FindPalletTags($id: Int!) {
    lot(id: $id) {
      id
      palletTags {
        id
        tagNumber
        cartonQuantity
        weight
      }
    }
  }
`;

export const FIND_PALLET_TAGS_WITH_LOCATION = gql`
  query FindPalletTagsWithLocation($id: Int!) @hasPrimaryCacheTarget {
    lot(id: $id) {
      id
      palletTags @primaryCacheTarget {
        id
        tagNumber
        cartonQuantity
        weight
        warehouseLocation {
          id
          description
        }
      }
    }
  }
`;
